import React, { useState } from 'react';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faHandHoldingHeart, faScaleBalanced, faBuilding, faUsers, faArrowRightArrowLeft, faBrain, faUserNurse } from '@fortawesome/free-solid-svg-icons';
import './paineis.css';

const PAINEIS = [
  {
    id: 'servico-social',
    titulo: 'SERVIÇO SOCIAL',
    icone: faHandHoldingHeart,
    cor: '#007932',
    corFundo: '#e6f4ec',
    src: 'https://app.powerbi.com/view?r=eyJrIjoiYjgxMzI3YmYtNTJlNC00YmQ5LWEzZDYtZmUwODFiMTkyNGRlIiwidCI6IjFkYTMyMjNlLTAyNWItNDEzMC1hM2YzLTJlYjY3NWY1NTFlNSJ9',
  },
  {
    id: 'juridico',
    titulo: 'JURÍDICO',
    icone: faScaleBalanced,
    cor: '#034ea2',
    corFundo: '#e6eef9',
    src: 'https://app.powerbi.com/view?r=eyJrIjoiOWYzMWU0MWQtMzU3OC00MjRkLWE4OTktMzMwM2ExNmE4ZjdiIiwidCI6IjFkYTMyMjNlLTAyNWItNDEzMC1hM2YzLTJlYjY3NWY1NTFlNSJ9',
  },
  {
    id: 'ocupacao',
    titulo: 'OCUPAÇÃO',
    icone: faBuilding,
    cor: '#b07a00',
    corFundo: '#fff8e1',
    src: 'https://app.powerbi.com/view?r=eyJrIjoiZjRkNjRkZWEtMmQ2MS00ZmE2LThjMzEtNWMyMzM0YmQwY2E3IiwidCI6IjFkYTMyMjNlLTAyNWItNDEzMC1hM2YzLTJlYjY3NWY1NTFlNSJ9',
  },
  {
    id: 'censo',
    titulo: 'CENSO',
    icone: faUsers,
    cor: '#5e35b1',
    corFundo: '#ede7f6',
    src: 'https://app.powerbi.com/view?r=eyJrIjoiZWI3YzZkODItY2NlOC00NTdiLThhZGMtMGYzMTYwODI0N2FiIiwidCI6IjFkYTMyMjNlLTAyNWItNDEzMC1hM2YzLTJlYjY3NWY1NTFlNSJ9',
  },
  {
    id: 'movimentacoes',
    titulo: 'MOVIMENTAÇÕES',
    icone: faArrowRightArrowLeft,
    cor: '#00796b',
    corFundo: '#e0f2f1',
    src: 'https://app.powerbi.com/view?r=eyJrIjoiMTBlNGMyNTQtZTQ5ZC00OWI5LWJmMTEtOWFlYWI1ODRkOWQ1IiwidCI6IjFkYTMyMjNlLTAyNWItNDEzMC1hM2YzLTJlYjY3NWY1NTFlNSJ9',
  },
  {
    id: 'psicologia',
    titulo: 'PSICOLOGIA',
    icone: faBrain,
    cor: '#8e24aa',
    corFundo: '#f3e5f5',
    src: 'https://app.powerbi.com/view?r=eyJrIjoiMWQ0MTAyNTgtODNhZi00OTRiLWEyMmItZjViZWY2OWEyODE5IiwidCI6IjFkYTMyMjNlLTAyNWItNDEzMC1hM2YzLTJlYjY3NWY1NTFlNSJ9',
  },
  {
    id: 'enfermagem',
    titulo: 'ENFERMAGEM',
    icone: faUserNurse,
    cor: '#c62828',
    corFundo: '#fdecea',
    src: 'https://app.powerbi.com/view?r=eyJrIjoiMDQzZTE4NTUtMjRmOC00ZGY0LWJlZWItNzU2Y2U3NDY1OGJiIiwidCI6IjFkYTMyMjNlLTAyNWItNDEzMC1hM2YzLTJlYjY3NWY1NTFlNSJ9',
  },
];

function Paineis() {
  const [painelAtivo, setPainelAtivo] = useState(null);

  const painel = PAINEIS.find((p) => p.id === painelAtivo);

  return (
    <div>
      <Sidebar />
      <Header />
      <div className={`container paineis-container${painelAtivo ? ' paineis-fullscreen' : ''}`}>
        {!painelAtivo ? (
          <div className="content">
            <h4 className="h4-title">Painéis</h4>
            <p className="paineis-subtitle">Selecione um painel para visualizar.</p>
            <div className="paineis-grid">
              {PAINEIS.map((p) => (
                <div
                  key={p.id}
                  role="button"
                  tabIndex={0}
                  className="painel-card"
                  onClick={() => setPainelAtivo(p.id)}
                  onKeyDown={(e) => e.key === 'Enter' && setPainelAtivo(p.id)}
                >
                  <div className="painel-card-accent" style={{ background: p.cor }} />
                  <div className="painel-card-icon-wrap" style={{ background: p.corFundo }}>
                    <FontAwesomeIcon icon={p.icone} style={{ color: p.cor, fontSize: 24 }} />
                  </div>
                  <span className="painel-card-titulo">{p.titulo}</span>
                  <span className="painel-card-label" style={{ color: p.cor }}>
                    Clique para abrir
                  </span>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div className="painel-viewer">
            <div className="painel-viewer-header">
              <button
                type="button"
                className="painel-back-btn"
                onClick={() => setPainelAtivo(null)}
              >
                <FontAwesomeIcon icon={faArrowLeft} /> Voltar
              </button>
              <h4 className="painel-viewer-titulo">{painel?.titulo}</h4>
            </div>
            <iframe
              title={painel?.titulo}
              src={painel?.src}
              className="painel-iframe"
              frameBorder="0"
              allowFullScreen
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Paineis;
